// Generated by purs version 0.15.0
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Map_Ordered from "../Data.Map.Ordered/index.js";
import * as Data_Map_Serialized from "../Data.Map.Serialized/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Set_Serialized from "../Data.Set.Serialized/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_Tuple_T2 from "../Data.Tuple.T2/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_I18n_Types from "../Restaumatic.I18n.Types/index.js";
import * as Restaumatic_Menu_V2_Types_Availability from "../Restaumatic.Menu.V2.Types.Availability/index.js";
import * as Restaumatic_Menu_V2_Types_Ids_EntityId from "../Restaumatic.Menu.V2.Types.Ids.EntityId/index.js";
import * as Restaumatic_Menu_V2_Types_MenuConsumer from "../Restaumatic.Menu.V2.Types.MenuConsumer/index.js";
import * as Restaumatic_Menu_V2_Types_Parametric_Parametric from "../Restaumatic.Menu.V2.Types.Parametric.Parametric/index.js";
import * as Restaumatic_Menu_V2_Types_Photo from "../Restaumatic.Menu.V2.Types.Photo/index.js";
import * as Restaumatic_Menu_V2_Types_Tags from "../Restaumatic.Menu.V2.Types.Tags/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var ComboChoice = function (x) {
    return x;
};
var ComboElement = function (x) {
    return x;
};
var Combo = function (x) {
    return x;
};
var newtypeCombo_ = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeComboElement_ = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeComboChoice_ = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldComboElement = function (dictHasField) {
    return dictHasField;
};
var hasFieldComboChoice = function (dictHasField) {
    return dictHasField;
};
var hasFieldCombo = function (dictHasField) {
    return dictHasField;
};
var eqComboChoice = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(Data_Map_Serialized.eqMap(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId)(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId))(x.customParameterValues)(y.customParameterValues) && Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_Menu_V2_Types_Parametric_Parametric.eqParametric(Data_Money_Rounded.eqMoney)))(x.priceOverride)(y.priceOverride) && Data_Eq.eq(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId)(x.product)(y.product);
        };
    }
};
var eqComboElement = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(Data_Map_Ordered.eqOMap(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId)(eqComboChoice))(x.choices)(y.choices) && Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId))(x.defaultChoice)(y.defaultChoice) && Data_Eq.eq(Restaumatic_I18n_Types.eqTranslated(Data_Eq.eqString))(x.description)(y.description) && Data_Eq.eq(Restaumatic_I18n_Types.eqTranslated(Data_Eq.eqString))(x.name)(y.name) && Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_Menu_V2_Types_Photo.eqPhoto))(x.photo)(y.photo) && x.skippable === y.skippable;
        };
    }
};
var eqCombo = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(Restaumatic_Menu_V2_Types_Availability.eqAvailability)(x.availability)(y.availability) && Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId))(x.availabilitySchedule)(y.availabilitySchedule) && Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId))(x.crossSellingList)(y.crossSellingList) && Data_Eq.eq(Restaumatic_I18n_Types.eqTranslated(Data_Eq.eqString))(x.description)(y.description) && Data_Eq.eq(Data_Map_Ordered.eqOMap(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId)(eqComboElement))(x.elements)(y.elements) && Data_Eq.eq(Data_Eq.eqArray(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId))(x.exchangeSuggestionList)(y.exchangeSuggestionList) && Data_Eq.eq(Restaumatic_I18n_Types.eqTranslated(Data_Eq.eqString))(x.name)(y.name) && Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_Menu_V2_Types_Photo.eqPhoto))(x.photo)(y.photo) && Data_Eq.eq(Data_Set_Serialized.eqSet(Restaumatic_Menu_V2_Types_Tags.eqTag))(x.tags)(y.tags) && Data_Eq.eq(Data_Set_Serialized.eqSet(Restaumatic_Menu_V2_Types_MenuConsumer.eqMenuConsumer))(x.visibleIn)(y.visibleIn);
        };
    }
};
var genericComboElement = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var genericComboChoice = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showComboChoice = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericComboChoice)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "customParameterValues";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "priceOverride";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "product";
        }
    })(Data_Show.showRecordFieldsNil)(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId))(/* #__PURE__ */ Data_Maybe.showMaybe(/* #__PURE__ */ Restaumatic_Menu_V2_Types_Parametric_Parametric.showParametric(Data_Money_Rounded.showMoney))))(/* #__PURE__ */ Data_Map_Serialized.showMap(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId)(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId)))))({
        reflectSymbol: function () {
            return "ComboChoice";
        }
    }))
};
var showComboElement = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericComboElement)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "choices";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "defaultChoice";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "description";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "photo";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "skippable";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Show.showBoolean))(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Menu_V2_Types_Photo.showPhoto)))(/* #__PURE__ */ Restaumatic_I18n_Types.showTranslated(Data_Show.showString)))(/* #__PURE__ */ Restaumatic_I18n_Types.showTranslated(Data_Show.showString)))(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId)))(/* #__PURE__ */ Data_Map_Ordered.showOMap(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId)(showComboChoice)))))({
        reflectSymbol: function () {
            return "ComboElement";
        }
    }))
};
var unscrambleDecodeComboChoice = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericComboChoice)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "customParameterValues";
        }
    })(/* #__PURE__ */ Data_Map_Serialized.udecodeMap(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(Restaumatic_Menu_V2_Types_Ids_EntityId.ufromJSONKey)(Restaumatic_Menu_V2_Types_Ids_EntityId.udecodeEntityId))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "priceOverride";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(/* #__PURE__ */ Restaumatic_Menu_V2_Types_Parametric_Parametric.udecodeParametric(Data_Money_Rounded.udecodeMoney)))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "product";
        }
    })(Restaumatic_Menu_V2_Types_Ids_EntityId.udecodeEntityId)(Unscramble.decodeRecordNil)))))))(Unscramble_Generic.defaultOptions)
};
var unscrambleDecodeComboElement = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericComboElement)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "choices";
        }
    })(/* #__PURE__ */ Data_Map_Ordered.udecodeMap(unscrambleDecodeComboChoice)(Restaumatic_Menu_V2_Types_Ids_EntityId.udecodeEntityId)(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "defaultChoice";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Menu_V2_Types_Ids_EntityId.udecodeEntityId))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "description";
        }
    })(/* #__PURE__ */ Restaumatic_I18n_Types.udecodeTranslated(Unscramble.decodeString1))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Restaumatic_I18n_Types.udecodeTranslated(Unscramble.decodeString1))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "photo";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Menu_V2_Types_Photo.unscrambleDecodePhoto))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "skippable";
        }
    })(Unscramble.decodeBoolean1)(Unscramble.decodeRecordNil))))))))))(Unscramble_Generic.defaultOptions)
};
var genericCombo = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showCombo = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericCombo)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "availability";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "availabilitySchedule";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "crossSellingList";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "description";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "elements";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "exchangeSuggestionList";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "photo";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "tags";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "visibleIn";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Set_Serialized.showSet(Restaumatic_Menu_V2_Types_MenuConsumer.showMenuConsumer)))(/* #__PURE__ */ Data_Set_Serialized.showSet(Restaumatic_Menu_V2_Types_Tags.showTag)))(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Menu_V2_Types_Photo.showPhoto)))(/* #__PURE__ */ Restaumatic_I18n_Types.showTranslated(Data_Show.showString)))(/* #__PURE__ */ Data_Show.showArray(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId)))(/* #__PURE__ */ Data_Map_Ordered.showOMap(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId)(showComboElement)))(/* #__PURE__ */ Restaumatic_I18n_Types.showTranslated(Data_Show.showString)))(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId)))(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId)))(Restaumatic_Menu_V2_Types_Availability.showAvailability))))({
        reflectSymbol: function () {
            return "Combo";
        }
    }))
};
var unscrambleDecodeCombo = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericCombo)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "availability";
        }
    })(Restaumatic_Menu_V2_Types_Availability.unscrambleDecodeAvailability)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "availabilitySchedule";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Menu_V2_Types_Ids_EntityId.udecodeEntityId))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "crossSellingList";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Menu_V2_Types_Ids_EntityId.udecodeEntityId))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "description";
        }
    })(/* #__PURE__ */ Restaumatic_I18n_Types.udecodeTranslated(Unscramble.decodeString1))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "elements";
        }
    })(/* #__PURE__ */ Data_Map_Ordered.udecodeMap(unscrambleDecodeComboElement)(Restaumatic_Menu_V2_Types_Ids_EntityId.udecodeEntityId)(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "exchangeSuggestionList";
        }
    })(/* #__PURE__ */ Unscramble.decodeArray1(Restaumatic_Menu_V2_Types_Ids_EntityId.udecodeEntityId))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Restaumatic_I18n_Types.udecodeTranslated(Unscramble.decodeString1))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "photo";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Menu_V2_Types_Photo.unscrambleDecodePhoto))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "tags";
        }
    })(/* #__PURE__ */ Data_Set_Serialized.udecodeSet(Restaumatic_Menu_V2_Types_Tags.ordTag)(Restaumatic_Menu_V2_Types_Tags.unscrambleDecodeTag))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "visibleIn";
        }
    })(/* #__PURE__ */ Data_Set_Serialized.udecodeSet(Restaumatic_Menu_V2_Types_MenuConsumer.ordMenuConsumer)(Restaumatic_Menu_V2_Types_MenuConsumer.unscrambleDecodeMenuConsumer))(Unscramble.decodeRecordNil))))))))))))))(Unscramble_Generic.defaultOptions)
};
var encodeComboChoice = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericComboChoice)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "ComboChoice";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "product";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_V2_Types_Ids_EntityId.encodeEntityId)))({
        reflectSymbol: function () {
            return "priceOverride";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(/* #__PURE__ */ Restaumatic_Menu_V2_Types_Parametric_Parametric.encodeParametric(Data_Money_Rounded.encodeMoney)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Money_Rounded.encodeMoney)))))))({
        reflectSymbol: function () {
            return "customParameterValues";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Data_Map_Serialized.encodeMap(Restaumatic_Menu_V2_Types_Ids_EntityId.asJSONKeyEntityId)(Restaumatic_Menu_V2_Types_Ids_EntityId.encodeEntityId)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_V2_Types_Ids_EntityId.encodeEntityId)))))))))
};
var encodeComboElement = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericComboElement)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "ComboElement";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "skippable";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.booleanEncode)))({
        reflectSymbol: function () {
            return "photo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Menu_V2_Types_Photo.encodePhoto))))({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Restaumatic_I18n_Types.encodeTranslated(Foreign_Generic_Class.stringEncode))))({
        reflectSymbol: function () {
            return "description";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Restaumatic_I18n_Types.encodeTranslated(Foreign_Generic_Class.stringEncode))))({
        reflectSymbol: function () {
            return "defaultChoice";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Menu_V2_Types_Ids_EntityId.encodeEntityId))))({
        reflectSymbol: function () {
            return "choices";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Data_Map_Ordered.encodeMap(/* #__PURE__ */ Data_Tuple_T2.encodeT2(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_V2_Types_Ids_EntityId.encodeEntityId)))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeComboChoice))))))))))
};
var encodeCombo = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericCombo)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Combo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "visibleIn";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Data_Set_Serialized.encodeSet(Restaumatic_Menu_V2_Types_MenuConsumer.encodeMenuConsumer))))({
        reflectSymbol: function () {
            return "tags";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Data_Set_Serialized.encodeSet(Restaumatic_Menu_V2_Types_Tags.encodeTag))))({
        reflectSymbol: function () {
            return "photo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Menu_V2_Types_Photo.encodePhoto))))({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Restaumatic_I18n_Types.encodeTranslated(Foreign_Generic_Class.stringEncode))))({
        reflectSymbol: function () {
            return "exchangeSuggestionList";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Restaumatic_Menu_V2_Types_Ids_EntityId.encodeEntityId))))({
        reflectSymbol: function () {
            return "elements";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Data_Map_Ordered.encodeMap(/* #__PURE__ */ Data_Tuple_T2.encodeT2(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_V2_Types_Ids_EntityId.encodeEntityId)))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeComboElement)))))))({
        reflectSymbol: function () {
            return "description";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Restaumatic_I18n_Types.encodeTranslated(Foreign_Generic_Class.stringEncode))))({
        reflectSymbol: function () {
            return "crossSellingList";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Menu_V2_Types_Ids_EntityId.encodeEntityId))))({
        reflectSymbol: function () {
            return "availabilitySchedule";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Menu_V2_Types_Ids_EntityId.encodeEntityId))))({
        reflectSymbol: function () {
            return "availability";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_V2_Types_Availability.encodeAvailability))))))
};
var decodeComboChoice = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericComboChoice)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "ComboChoice";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "product";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_V2_Types_Ids_EntityId.decodeEntityId))())({
        reflectSymbol: function () {
            return "priceOverride";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(/* #__PURE__ */ Restaumatic_Menu_V2_Types_Parametric_Parametric.decodeParametric(Data_Money_Rounded.decodeMoney)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_Money_Rounded.decodeMoney))))))())({
        reflectSymbol: function () {
            return "customParameterValues";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Data_Map_Serialized.decodeMap(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(Restaumatic_Menu_V2_Types_Ids_EntityId.asJSONKeyEntityId)(Restaumatic_Menu_V2_Types_Ids_EntityId.decodeEntityId)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_V2_Types_Ids_EntityId.decodeEntityId)))))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
var decodeComboElement = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericComboElement)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "ComboElement";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "skippable";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.booleanDecode))())({
        reflectSymbol: function () {
            return "photo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Menu_V2_Types_Photo.decodePhoto)))())({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Restaumatic_I18n_Types.decodeTranslated(Foreign_Generic_Class.stringDecode)))())({
        reflectSymbol: function () {
            return "description";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Restaumatic_I18n_Types.decodeTranslated(Foreign_Generic_Class.stringDecode)))())({
        reflectSymbol: function () {
            return "defaultChoice";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Menu_V2_Types_Ids_EntityId.decodeEntityId)))())({
        reflectSymbol: function () {
            return "choices";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Data_Map_Ordered.decodeMap(/* #__PURE__ */ Data_Tuple_T2.decodeT2(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_V2_Types_Ids_EntityId.decodeEntityId)))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeComboChoice))))(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
var decodeCombo = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericCombo)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "Combo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "visibleIn";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Data_Set_Serialized.decodeSet(Restaumatic_Menu_V2_Types_MenuConsumer.ordMenuConsumer)(Restaumatic_Menu_V2_Types_MenuConsumer.decodeMenuConsumer)))())({
        reflectSymbol: function () {
            return "tags";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Data_Set_Serialized.decodeSet(Restaumatic_Menu_V2_Types_Tags.ordTag)(Restaumatic_Menu_V2_Types_Tags.decodeTag)))())({
        reflectSymbol: function () {
            return "photo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Menu_V2_Types_Photo.decodePhoto)))())({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Restaumatic_I18n_Types.decodeTranslated(Foreign_Generic_Class.stringDecode)))())({
        reflectSymbol: function () {
            return "exchangeSuggestionList";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(Restaumatic_Menu_V2_Types_Ids_EntityId.decodeEntityId)))())({
        reflectSymbol: function () {
            return "elements";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Data_Map_Ordered.decodeMap(/* #__PURE__ */ Data_Tuple_T2.decodeT2(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_V2_Types_Ids_EntityId.decodeEntityId)))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeComboElement))))(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)))())({
        reflectSymbol: function () {
            return "description";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Restaumatic_I18n_Types.decodeTranslated(Foreign_Generic_Class.stringDecode)))())({
        reflectSymbol: function () {
            return "crossSellingList";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Menu_V2_Types_Ids_EntityId.decodeEntityId)))())({
        reflectSymbol: function () {
            return "availabilitySchedule";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Menu_V2_Types_Ids_EntityId.decodeEntityId)))())({
        reflectSymbol: function () {
            return "availability";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_V2_Types_Availability.decodeAvailability))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    ComboElement,
    ComboChoice,
    Combo,
    genericComboElement,
    eqComboElement,
    showComboElement,
    encodeComboElement,
    decodeComboElement,
    unscrambleDecodeComboElement,
    hasFieldComboElement,
    newtypeComboElement_,
    genericComboChoice,
    eqComboChoice,
    showComboChoice,
    encodeComboChoice,
    decodeComboChoice,
    unscrambleDecodeComboChoice,
    hasFieldComboChoice,
    newtypeComboChoice_,
    genericCombo,
    eqCombo,
    showCombo,
    encodeCombo,
    decodeCombo,
    unscrambleDecodeCombo,
    hasFieldCombo,
    newtypeCombo_
};
//# sourceMappingURL=index.js.map
